import { render, staticRenderFns } from "./add-new-detail.vue?vue&type=template&id=e5682d92&"
import script from "./add-new-detail.vue?vue&type=script&lang=js&"
export * from "./add-new-detail.vue?vue&type=script&lang=js&"
import style0 from "./add-new-detail.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports